import { Controller } from "@hotwired/stimulus"

// Il confronto delle versioni delle bozze (turbo-frame "app-prep-confronto" di readiness/app_prep/_confronto): in React
// la coppia scelta (cmpA, cmpB) restava nello stato anche quando la pagina si rileggeva (loadProject, onAnalisi). Dopo
// che un menu è cambiato, un morph della pagina o del pannello salta il frame (turbo:before-morph-element), così la
// coppia scelta e il suo confronto restano; il frame sparisce con il pannello in attesa di una nuova preparazione.
//   <turbo-frame data-controller="confronto-bozze"
//     data-action="change->confronto-bozze#scelto turbo:before-morph-element->confronto-bozze#trattieni">
export default class extends Controller {
  scelto() {
    this.cambiato = true
  }

  trattieni(event) {
    if (event.target === this.element && this.cambiato) event.preventDefault()
  }
}
